import React from 'react';
import { Button, Table, Divider, Icon, Header, Popup, Loader } from 'semantic-ui-react';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import moment from 'moment';

import AddDisciplinaryMeasures from './AddDisciplinaryMeasures';
import { FiltersOnStyle, IconHeader } from '../../Professor/ProfessorInputGrades/css';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

class DisciplinaryMeasuresStatus extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dataActive: [],
            dataPast: [],

            newStartDate: new Date(),
            newEndDate: new Date(),
            newDocumentNumber: '',
            newMeasure: null,

            newComment: '',
            newId: null,
            newOptLock: null,

            showAddForm: false,
            showEditForm: false

        };
        this.updateStatus = this.updateStatus.bind(this);
        this.onRemoveDisciplinaryMeasure = this.onRemoveDisciplinaryMeasure.bind(this);
    }


    componentDidMount() {
        this.updateStatus();
    }

    onRemoveDisciplinaryMeasure(id) {
        this.setState({ loader: true });
        axios.delete(`/disciplinary-procedure/delete/${id}`)
            .then(res => {
                this.setState({ loader: false });
                this.updateStatus();
            })
            .then(res => {
                toast('Disciplinska mjere je uspješno izbrisana.');
            })
            .catch(err => {
                toast('Došlo je do greške.');
            });
    }

    updateStatus() {
        this.setState({ loader: true });
        axios.get(`/disciplinary-procedure/student-study-program/${this.props.studentStudyProgramId}/`)
            .then(res => {
                const dataActive = res.data;
                this.setState({ dataActive, loader: false });
                this.props.updateStudentStatuses();
            })
            .catch(err => {
                console.log('Failed to fetch active data.');
            });

        // axios.get(`/disciplinary-procedure/student-study-program/${this.props.studentId}/past/`)
        //     .then(res => {
        //         const dataPast = res.data;
        //         this.setState({ dataPast });
        //     })
        //     .catch(err => {
        //         console.log('Failed to fetch past data.');
        //     });
    }

    render() {
        return (<div>

            {this.state.showAddForm && <AddDisciplinaryMeasures
                studentStudyProgramId={this.props.studentStudyProgramId}
                updateStatus={this.updateStatus}
                toggleDisciplinaryVisibility={this.props.toggleDisciplinaryVisibility}
                closeForm={() => this.setState({ showAddForm: false })}
            />}

            {this.state.showEditForm && <AddDisciplinaryMeasures
                edit
                studentStudyProgramId={this.props.studentStudyProgramId}
                updateStatus={() => this.updateStatus()}
                closeForm={() => this.setState({ showEditForm: false })}
            />}

            {(!this.state.showAddForm && !this.state.showEditForm) && !this.props.limitation &&
            <div>
                <Header style={IconHeader} floated="right" >
                    <Button
                        disabled={localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                        floated="right"
                        icon
                        labelPosition="right"
                        color="blue"
                        size="small"
                        style={FiltersOnStyle}
                        onClick={() => { this.setState({ showAddForm: true }); window.scrollTo(0, 0); }}
                    ><Icon className="add" />
                        Dodavanje disciplinske mjere
                    </Button>
                </Header>
            </div>}
            <br />

            <div>

                {/* <h3>Disciplinske mjere</h3> */}
                <br />
                {this.state.loader ? <div style={{ paddingTop: '50px' }}><Loader active inline="centered" /></div> :
                    this.state.dataActive.length ? <Table celled selectable compact >
                        <Table.Header>
                            <Table.Row>

                                <Table.HeaderCell>Disciplinska mjera</Table.HeaderCell>
                                <Table.HeaderCell>Datum početka</Table.HeaderCell>
                                <Table.HeaderCell>Datum kraja</Table.HeaderCell>
                                <Table.HeaderCell>Broj odluke </Table.HeaderCell>
                                <Table.HeaderCell>Napomena</Table.HeaderCell>
                                <Table.HeaderCell />
                            </Table.Row>
                        </Table.Header>
                        <Table.Body>
                            {this.state.dataActive.map((el, index) =>
                                (<Table.Row key={index}>
                                    <Table.Cell verticalAlign="middle">
                                        {el.disciplinaryMeasure.name}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {moment(el.startDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {moment(el.endDate).format('D. M. YYYY.')}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.documentNumber}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle">
                                        {el.comment}
                                    </Table.Cell>
                                    <Table.Cell verticalAlign="middle" textAlign="center">
                                        <Popup
                                            content="Izmjena disciplinske mjere"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={(!this.props.disciplinaryMeasure && this.props.limitation) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                    basic="true"
                                                    circular
                                                    icon="pencil"
                                                    size="small"
                                                    color="green"
                                                    onClick={() => {
                                                        localStorage.setItem('disciplinaryMeasuresObject', JSON.stringify(el));
                                                        this.setState({ showEditForm: true, disciplinaryMeasuresObject: el });
                                                        window.scrollTo(0, 0);
                                                    }}
                                                >
                                                </Button>}
                                        />
                                        <Popup

                                            content="Obriši"
                                            position="top center"
                                            trigger={
                                                <Button
                                                    disabled={(!this.props.disciplinaryMeasure && this.props.limitation) || localStorage.getItem('activeRole') === 'AIDA' || localStorage.getItem('activeRole').substr(0, 19) === 'Prodekan za nastavu' || localStorage.getItem('activeRole').startsWith('Prodekan za međunarodnu')}
                                                    basic="true"
                                                    circular
                                                    icon="trash alternate"
                                                    size="small"
                                                    color="red"
                                                    onClick={() => this.onRemoveDisciplinaryMeasure(el.id)}
                                                />}
                                        />

                                    </Table.Cell>
                                </Table.Row>))}
                        </Table.Body>
                    </Table> : 'Nema podataka o disciplinskim mjerama.'}
            </div>

            <ToastContainer hideProgressBar />
        </div>
        );
    }
}
export default DisciplinaryMeasuresStatus;



// WEBPACK FOOTER //
// ./src/views/StudentService/StudentOverview/DisciplinaryMeasuresStatus.js